
import { Component, Vue } from 'vue-property-decorator'
import api from '@/plugins/api'
// @ts-ignore
import { addToCartSuccess } from '@/plugins/popups'
import eventBus from '@/plugins/eventBus'
import { ItemModel } from '@/store/models/ItemModel'
import { getParameter } from '@/plugins/globals'
import '@/theme/scss/components/item.scss'
import {
  CarouselNextLabel,
  CarouselPrevLabel,
  carouselOption,
} from '@/plugins/globalStaticDatas'
import { FavoritesStore } from '@/store/stores/FavoritesStore'

@Component({})
export default class Categories extends Vue {
  productsInOffer: any = []
  PHOTO_URL: string = process.env.VUE_APP_PHOTO_URL
  showComponent: boolean = false
  sectorId: any
  carouselOption: Object = carouselOption
  nextLabel: any = CarouselNextLabel()
  prevLabel: any = CarouselPrevLabel()
  favoritesStore: FavoritesStore = FavoritesStore.getInstance()

  mounted() {
    api()
      .get(`products/on-offer`)
      .then((response) => {
        // this.showComponent = true
        console.log('products in ofer response', response) //TODO: delete logs
        if (response && response.data.data.length > 0) {
          this.showComponent = true
          this.productsInOffer = response.data.data.map((itemData: any) => {
            Object.assign(itemData, {
              isFavorite: this.isProductFavorite(itemData),
            })
            let item = new ItemModel()
            item.factory(itemData)
            return item
          })
        } else {
          // this.showComponent = false
          this.productsInOffer = []
        }
      })
      .catch((err) => {
        console.log(err)
      })
    this.sectorId = getParameter('sector_id')
    //  this.favoritesStore.fetchData()
  }
  viewModal(product: any) {
    eventBus.$emit('item_modal', product)
  }
  addToCart(product: ItemModel) {
    if (product.outOfStock) {
      return
    }
    eventBus.$emit('cart:item-added', product)
    addToCartSuccess()
  }
  addToFavorites(product: any) {
    product.addToFavorites()
    // product.isFavorite = true
  }
  isProductFavorite(product: ItemModel) {
    const productExists = (obj: any) => obj.id === product.id
    let isFavorite = this.favoritesStore.getStore().some(productExists)
    return isFavorite
  }
  productName(productName: string) {
    if (productName === null) return 'Nuk Ka Emër'
    if (productName.split('').length > 50) {
      return `${productName.split(' ').slice(0, 8).join(' ')}...`
    }
    return productName
  }
}
